
export const uiSchema = {
  
};

// There's no class here as a page is abstract - it's implemented by all layouts in the folder of the same name
